var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileText({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#383838"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Signature applied"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393,
    height: 852,
    transform: "translate(-249 -705)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fields options"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1171277496"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15.5,
    y: -15.5,
    width: 77,
    height: 47,
    rx: 11.5,
    stroke: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi_3188004"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -8,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#E9E8ED"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi_3856192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66667 13H10.0893C10.4573 13 10.5 13.132 10.5 13.5C10.5 13.868 10.368 14 10 14H6C5.632 14 5.5 13.868 5.5 13.5C5.5 13.132 5.632 13 6 13H7.5V3.04466L3 3V4.66667C3 5.03467 2.868 5.5 2.5 5.5C2.132 5.5 2 5.03467 2 4.66667V2.66667C2 2.29867 2.29867 2 2.66667 2H13.3333C13.7013 2 14 2.29867 14 2.66667V4.66667C14 5.03467 13.868 5.5 13.5 5.5C13.132 5.5 13 5.03467 13 4.66667V3H8.66667V13Z",
    fill: "#1E1341"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileText);
export default __webpack_public_path__ + "static/media/MobileText.3b7af7acb35d87aa6c3eaab98a9a57dc.svg";
export { ForwardRef as ReactComponent };